<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">

            <template v-slot:[`item.bookingDate`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYHHSSDateFormat(item.bookingDate) }}
                </span>
            </template>

            <template v-slot:[`item.travelDate`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYDateFormat(item.travelDate) }}
                </span>
            </template>

            <template v-slot:[`item.total`]="{ item }">
                <span>
                    {{ $util.getCurrencyFormat(item.total) }}
                </span>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'BookingTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                return {
                    ...item,
                    bookingDate: item.createdAt,
                    travelDate: item.visitDate,
                    userFirstName: item?.user?.name,
                    userLastName: item?.user?.lastname,
                    amount: item.products?.reduce((total, current) => total + current.Quantity, 0),
                    total: item.products?.reduce((total, current) => total + (current.price * current.Quantity), 0)
                }
            }
        })
    ],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('bookingList.table.header.bookingNo'),
                    value: 'id',
                    sortable: false
                },
                {
                    text: this.$t('bookingList.table.header.bookingDate'),
                    value: 'bookingDate'
                },
                {
                    text: this.$t('bookingList.table.header.travelDate'),
                    value: 'travelDate'
                },
                {
                    text: this.$t('bookingList.table.header.firstName'),
                    value: 'userFirstName',
                    sortable: false
                },
                {
                    text: this.$t('bookingList.table.header.lastName'),
                    value: 'userLastName',
                    sortable: false
                },
                {
                    text: this.$t('bookingList.table.header.items'),
                    value: 'amount',
                    align: 'center',
                    sortable: false
                },
                {
                    text: this.$t('bookingList.table.header.total'),
                    value: 'total',
                    width: '120px',
                    align: 'right',
                    sortable: false
                }
            ]
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
